import React from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";

export const TexasGroupingDetails: React.FC = () => {
  const formMethods = useFormContext();

  return (
    <>
      <div className="bg-bgDB mr-3 pb-1">
        <div className="bg-white box-shadow rounded-lg h-full">
          <div className="flex items-center space-x-1 cursor-pointer my-3">
            <div className="grid grid-cols-1 md:grid-cols-2 mx-3 pb-2 gap-2 gap-x-2 py-2">
              <div className="my-3 mx-3">
                <TextInputLabelHookForm
                  name="texasGroupingName"
                  label="Texas Grouping Name"
                  type="text"
                  className={
                    formMethods.formState.errors.texasGroupingName &&
                    formMethods.formState.errors.texasGroupingName.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={formMethods.register("texasGroupingName", {
                    required: {
                      value: true,
                      message: "Required Field",
                    },
                  })}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TexasGroupingDetails;
